import { ReactComponent as Logo } from "./assets/logo.svg";
import { ReactComponent as ViewList } from "./assets/view-list.svg";
import { ReactComponent as MobileInternet } from "./assets/mobile-internet.svg";
import { Picker, Button, Space, Toast } from "antd-mobile";
import { useNavigate, useParams } from "react-router-dom";
import { ReactNode, useContext, useEffect, useMemo, useState } from "react";
import { PickerValue } from "antd-mobile/es/components/picker-view";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "@src/Basic/Language/Provider.tsx";
import _ from "lodash";
import GlobalConfig from "@src/GlobalConfig";
import NavList from "./navList";
import styles from "./index.module.less";

const MobileHeader = () => {
  const navigator = useNavigate();
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<PickerValue[]>([i18n.language]);
  const [languageDataSource, setLanguageDataSource] = useState<any[]>([]);
  const { setLanguage, language } = useContext(LanguageContext);
  const [navListVisible, setNavListVisible] = useState<boolean>(false);

  useEffect(() => {
    try {
      const allSupportLanguages = localStorage.getItem("languageList");
      const parseAllSupportLanguages = JSON.parse(allSupportLanguages ?? "[]");

      if (allSupportLanguages) {
        setLanguageDataSource(parseAllSupportLanguages);
      }
    } catch (error) {
      //
    }
  }, [i18n.language]);

  const handleLanguage = (lang: any) => {
    setLanguage(lang);
    const item = _.find(languageDataSource, { value: lang });
    if (item?.isForeign) {
      GlobalConfig.pushToInternational();
    }
  };

  const handleVisible = (visible: boolean) => {
    setNavListVisible(visible);
  };

  return (
    <div className={`${styles.mobileHeader} flex justify-between items-center`}>
      <Logo
        onClick={() => {
          navigator(`/${lang}/home`);
        }}
      />
      <div>
        <MobileInternet
          className={styles.mobileInternetIcon}
          onClick={() => {
            setVisible(true);
          }}
        />
        <ViewList
          onClick={() => {
            setNavListVisible(true);
          }}
        />
        <Picker
          title={<span>语言</span>}
          columns={[languageDataSource]}
          visible={visible}
          onClose={() => {
            setVisible(false);
          }}
          value={value}
          onConfirm={(v) => {
            setValue(v);
            handleLanguage(v?.[0]);
          }}
        />
      </div>
      <NavList visible={navListVisible} handleVisible={handleVisible} />
    </div>
  );
};
export default MobileHeader;
